import {curry, forEach} from 'ramda';
import addEvent from './addEvent';

const bindEvent = curry((eventElement, event, callback) => {
	forEach(
		addEvent(event, callback),
		document.querySelectorAll(eventElement)
	);
});

export default bindEvent;



// WEBPACK FOOTER //
// ./app/scripts/util/bindEvent.js